<template>
  <div class="about_alliances" style="min-width:1440px;" >
    <div class="second_banner animated fadeIn">
      <!-- <img class="banner_img" src="../assets/img/union_banner.png" alt /> -->
      <img class="banner_img" :src="img.data.data.url" alt />
    </div>
    <div class="second_main animated fadeInUp" style="padding-left:20%;padding-right:20%">
      <div>
        <el-tabs v-model="activeName"  @tab-click="handleClick">
          <el-tab-pane class="second_maintop" :label="chOrEn=='1'?'展览':'Exhibition'" name="one">
              <span slot="label">
                <i class="el-icon-caret-right" v-if="activeName=='one'"></i>
                <span style=";font-weight: bold;" v-if="chOrEn=='1'">展览</span>
                <span style=";font-weight: bold;" v-else>Exhibition</span>
                <!-- <img class="banner_img" src="../assets/img/zuoBiao.png" alt  /> -->
              </span>
              <div class="meeting_content" v-for="item in list">
                  <!-- <div class="meeting_content_list">
                    <div class="meeting_content_listdiv">第二届会议</div>
                    <div class="meeting_content_listdiv">2017-05-20</div>
                  </div> -->
                  <div class="meeting_content_list" style="cursor:pointer;margin-bottom:40px" @click="toforumarticles2(item)">
                    <div class="meeting_content_listdiv">{{item.title}}</div>
                    <!-- <div class="meeting_content_listdiv">{{item.createTime}}</div> -->
                  </div>
                  <!-- <div style="color:#77818E;margin-bottom:40px">{{item.content}}</div> -->
              </div>
              <div class="block"  v-if="exhibition.total > exhibition.pageSize">
                <el-pagination
                  @current-change="handleExhibitionCurrentChange"
                  :current-page.sync="exhibition.currentPage"
                  :page-size="exhibition.pageSize"
                  layout="total, prev, pager, next"
                  :total="exhibition.total">
                </el-pagination>
              </div>
          </el-tab-pane>
          <el-tab-pane class="second_maintop" :label="chOrEn=='1'?'交流':'Communication'" name="two">
              <span slot="label">
                <i class="el-icon-caret-right" v-if="activeName=='two'"></i>
                <span style=";font-weight: bold;" v-if="chOrEn=='1'">交流</span>
                <span style=";font-weight: bold;" v-else>Communication</span>
                <!-- <img class="banner_img" src="../assets/img/zuoBiao.png" alt  /> -->
              </span>
              <div class="meeting_content" v-for="item in lists" >
                  <div class="meeting_content_list" style="cursor:pointer;margin-bottom:40px" @click="toforumarticles2(item)">
                    <div class="meeting_content_listdiv">{{item.title}}</div>
                    <!-- <div class="meeting_content_listdiv">{{item.createTime}}</div> -->
                  </div>
                  <!-- <div style="color:#77818E;margin-bottom:40px">{{item.content}}</div> -->
                  <!-- <div class="meeting_content_list">
                    <div class="meeting_content_listdiv">第四届会议</div>
                    <div class="meeting_content_listdiv">2017-05-01</div>
                  </div> -->
              </div>
              <div class="block" v-if="exchange.total > exchange.pageSize">
                <el-pagination
                  @current-change="handleExchangeCurrentChange"
                  :current-page.sync="exchange.currentPage"
                  :page-size="exchange.pageSize"
                  layout="total, prev, pager, next"
                  :total="exchange.total">
                </el-pagination>
              </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import videoPoster from "@/assets/img/meeting_video.png";
import { articleList,articlePage,getByNav } from '../api/api'
export default {
  name: "company",
  data() {
    return {
        chOrEn:sessionStorage.getItem('chOrEn'),
        list:"",
        lists:"",
        exhibition:{
          total:0,
          pageSize:10,
          currentPage:1,
        },
        exchange:{
          total:0,
          pageSize:10,
          currentPage:1,
        },
        img:'',
        activeName:'two',
        playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], //可选择的播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "",
            src: "http://192.144.163.183:8066/mp4.mp4", //url地址
          },
        ],
        poster: videoPoster, //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: true, //全屏按钮
        },
      },
    };
  },
  created(){
    // let navigationId = {
    //   navigationId:2
    // }
    // articleList({navigationId}).then(res=>{
    //   console.log(res)
    // })
    let navigationIds = {
      navigationId:15
    }
    articlePage({...navigationIds}).then(res=>{
      this.list=res.data.page.rows
      this.exhibition.total = res.data.page.total
    })
    navigationIds = {
      navigationId:16
    }
    articlePage({...navigationIds}).then(res=>{
      this.lists=res.data.page.rows
      this.exchange.total = res.data.page.total
    })
    let getBynavid = {
      navigationId:4
    }
    getByNav({...getBynavid}).then(res=>{
      this.img = res
    })
  },
  methods:{
    handleExhibitionCurrentChange(val){
      let navigationIds = {
        navigationId:15,
        page:val
      }
      articlePage({...navigationIds}).then(res=>{
        this.list=res.data.page.rows
      })
    },
    handleExchangeCurrentChange(val){
      let navigationIds = {
        navigationId:16,
        page:val
      }
      articlePage({...navigationIds}).then(res=>{
        this.lists=res.data.page.rows
      })
    },
    handleClick(tab) {
        console.log(tab.name)

    },
    toforumarticles2(item){
      this.$router.push({
        path: '/aboutAlliances/aboutAlliances1',
          query:{list: item.id,chOrEn:sessionStorage.getItem("chOrEn")}
        })
    }
  }
};
</script>
<style>
  #app /deep/ .el-tabs__item.is-active{
    color:#24367D;
    font-size: 20px;
    font-weight: bold;
  }
  .el-tabs__item{
    color:#77818E;
    font-size: 20px;
    font-weight: 400;
  }
</style>
<style lang="less" scoped>
.about_alliances {
  width: 100%;
//   height: 100%;
  /deep/ .el-tabs__item {
    // width: 200px;
    padding:0 10px!important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 20px;
  }
  .banner_img{
    height:400px
  }
  .second_main{
      .second_maintop{
        padding-top: 52px;
        padding-left: 0 !important;
        .meeting_content_list{
          display: -webkit-flex;
          display: flex;
          -webkit-justify-content: space-between;
          justify-content: space-between;
          padding-bottom: 30px;
          height: 18px;
        }
        .meeting_content_listdiv{
          height: 18px;
          color: #2C2C2C;
          font-size: 18px;
          line-height: 18px;
          font-family: SourceHanSansCN-Light, SourceHanSansCN;
        }
          .three_imgs{
            display: flex;
            width: 100%;
            align-items: center;
            justify-content: space-between;
            margin:10px 0;
            .img_box{
                width: 266px;
                height: 182px;
                overflow: hidden;
                cursor: pointer;
                img{
                    width: 100%;
                    height: 100%;
                    transition: all 1s ease;
                }
                img:hover{
                    transform: scale(1.2);
                }
            }
          }
          .two_imgs{
              display: flex;
              justify-content: space-between;
              margin:15px 0 ;
               .two_img_item{
                    width: 400px;
                    height: 280px;
                    overflow: hidden;
                cursor: pointer;
                    img{
                        width: 100%;
                        height: 100%;
                         transition: all 1s ease;
                    }
                    img:hover{
                    transform: scale(1.2);
                }
            }
          }
          h4{
              text-align: right;
              font-size: 14px;
              color: #606060;
              line-height: 30px;
          }
          h2{
              font-size: 18px;
              line-height: 50px;
              text-align: center;
              color: #2F2F2F;
              font-weight: 700;
          }
      }
      
  }
}
</style>